export const parseExceptionReason = (value: string) => {
  let result = []
  if (value) {
    try {
      result = JSON.parse(value)
    } catch (e: any) {
      result = [value]
    }
  }

  return result
}
